export default __webpack_public_path__ + "static/media/default.9deffe6bf52b4f754cf02af969a7ac57.png";